import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { DisclaimerModalComponent } from './disclaimer-modal.component';
import { overlayConfigFactory } from 'ngx-modialog';

@Injectable()
export class DisclaimerModalService {
    constructor(public modal: Modal) {}

    openDialog(disclaimerData: string, viewContainer:ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
        return this.modal.open(DisclaimerModalComponent, overlayConfigFactory({disclaimerData: disclaimerData}, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/disclaimer-modal/disclaimer-modal.service.ts